import React from 'react'
import { css } from 'emotion'
// import Waypoint from 'react-waypoint'

const baseClass = css`
  padding: 2rem 1rem;

  @media (min-width: 800px) {
		padding: 3rem 5rem;
  }
  @media (min-width: 1025px) {
		padding: 3rem 10rem;
	}
`

const lightClass = css`
  background: #F8F8F8;
`

const shadingClass = css`
  position: relative;
  overflow: hidden;
`

const Shading1 = css`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 20%;
  border-bottom: 100vh solid rgba(0, 0, 0, 0.03);
  border-left: 20rem solid transparent;
  right: 0;
  z-index: 0;
`

const Shading2 = css`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 32%;
  border-bottom: 100vh solid rgba(0, 0, 0, 0.03);
  border-left: 50rem solid transparent;
  right: 0;
  z-index: 0;
`

const animatedClass = css`
  opacity: 0;
  transition: .25s ease-out;
  transition-delay: 500ms;
  transform: translateY(-100px);

  &.is-active {
    opacity: 1;
    transform: translateY(0px);
  }
`

const anchor = css`
  position: relative;
  top: -6rem;
  display: block;
`

class SectionView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false
    }
  }

  render() {
    const styles = `${baseClass} ${this.props.light ? lightClass : ''} ${this.props.className || ''} ${this.props.shading ? shadingClass : ''}`

    // ${this.props.animated ? (
    //   this.state.visible ? `${animatedClass} is-active` : animatedClass 
    // ) : ''}

    return (
      <section className={styles}>
        <a id={this.props.id} className={anchor} />
        {/*<Waypoint
          onEnter={() => this.setState({ visible: true })}
          onLeave={() => this.setState({ visible: true })}
        />*/}
        {this.props.shading ? (
          <div className={Shading1}/>
        ) : null}
        {this.props.shading ? (
          <div className={Shading2}/>
        ) : null}  
        {this.props.children}
      </section>
    )
  }
}
 
export default SectionView;


// WEBPACK FOOTER //
// ./src/components/section.js